import React, { useEffect, useState } from 'react';
import { T, Lang } from '../lib/i18n';
export function UrgencyBar({
  lang
}: {
  lang: Lang;
}) {
  const [spots, setSpots] = useState(3);
  useEffect(() => {
    const i = setInterval(() => {
      if (Math.random() < 0.003) setSpots(p => Math.max(1, p - 1));
    }, 4000);
    return () => clearInterval(i);
  }, []);
  const endOfMonth = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);
  const monthName = endOfMonth.toLocaleDateString(lang === 'es' ? 'es-ES' : 'en-US', {
    month: 'long'
  });
  const formattedDate = `${endOfMonth.getDate()} de ${monthName}`;
  const enFormattedDate = `${monthName} ${endOfMonth.getDate()}`;
  return <div className="w-full bg-shimmer text-white py-2 px-4 text-center z-50 relative animate-shimmer" data-id="element-386">
      <p className="text-[0.72rem] uppercase tracking-[1.5px] font-bold font-body" data-id="element-387">
        {T[lang].urgency.text1}
        <span className="text-brand-gold-light" data-id="element-388">{spots}</span>
        {T[lang].urgency.text2}
        {lang === 'es' ? formattedDate : enFormattedDate}
      </p>
    </div>;
}